import useScrollTrigger from "@mui/material/useScrollTrigger";
import React from "react";

interface Props {
  children?: React.ReactElement<{ elevation?: number }>;
}

export default function ElevationScroll(props: Props) {
  const { children } = props;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return children
    ? React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
      })
    : null;
}
